module.exports = __webpack_public_path__ + "media/images/lb/547-732b8d5eca5254932a515f3a9d1f8972.svg";